import React from 'react';
import { Grid, withStyles, StyledComponentProps, Typography, Divider } from '@material-ui/core';
import HourPicker from '../../../../ui-components/HourPicker/HourPicker';
import NumericField from '../../../../ui-components/NumericField/NumericField';
import { time } from '../../../../model/room';
import { styles } from './styles';

interface IProps {
    dayName: string;
    openingTime?: time;
    closingTime?: time;
    duration?: number;
    onClosingTimeChange: (hour: number, minutes: number) => any;
    onOpeningTimeChange: (hour: number, minutes: number) => any;
    onDurationChange: (duration: number) => any;
}
const DayRowComp = (props: IProps & StyledComponentProps) => {
    return (
        <Grid container className={props.classes.RowContainer}>
            <Grid item sm={3}>
                <Typography>{props.dayName}</Typography></Grid>
            <Grid item sm={3} className={props.classes.Input}>
                <HourPicker
                    label="Inizio"
                    //name="sunday.openingTime"
                    value={props.openingTime}
                    onChange={(h, m) => props.onOpeningTimeChange(h, m)}
                />
            </Grid>
            <Grid item sm={3} className={props.classes.Input}>
                <HourPicker
                    label="Fine"
                    //name="sunday.closingTime"
                    value={props.closingTime}
                    onChange={(h, m) => props.onClosingTimeChange(h, m)}
                />
            </Grid>
            <Grid item sm={3} className={props.classes.Input}>
                <NumericField
                    label="Durata"
                    //name="sunday.duration"
                    value={props.duration}
                    onChange={d => props.onDurationChange(d)}
                />
            </Grid>
            <Divider className={props.classes.Divider} />
        </Grid>)
}

export const DayRow = withStyles(styles)(DayRowComp)